import React, { useState, useEffect, useCallback } from 'react';
import {
  C, S, Badge, StatusBadge, FormField, ErrList, StatCard,
  PageHeader, FilterBar, DataTable, Modal, FormGrid,
  useToast, useConfirm, useCRUD,
} from '../../components/inventoryShared';

import {
  categoryController, subCategoryController, brandController,
  unitController, productController, warehouseController,
  locationController, supplierController, purchaseOrderController,
  purchaseReturnController, stockInController, stockOutController,
  stockTransferController, stockAdjustmentController,
  stockController, reportController,
} from '../../controllers/inventoryController';
import ActionBtns from './ActionBtns';
import FormModal from './FormModal';
import makeSimplePage from './makeSimplePage';
import {
  Tag, Layers, Boxes, Settings, Package, BarChart3,
  PackageCheck, TrendingDown, ArrowLeftRight, ClipboardList,
  Users, ShoppingCart, RotateCcw, Warehouse, MapPin,
  AlertTriangle, Receipt, FileText, QrCode, Plus,
  Edit2, Trash2, Eye, Download, RefreshCw, CheckCircle,
  XCircle, Truck, ChevronDown, ChevronUp, Search,
} from 'lucide-react';
const fmt   = (d) => d ? new Date(d).toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' }) : '—';
const money = (v) => `₹${Number(v || 0).toLocaleString('en-IN')}`;
// ─────────────────────────────────────────────────────────────────────────────
// 10. PURCHASE RETURNS PAGE
// ─────────────────────────────────────────────────────────────────────────────
export const PurchaseReturnsPage = makeSimplePage({
  title:'Purchase Returns', subtitle:'Manage supplier returns', Icon:RotateCcw, color:C.danger,
  ctrl:purchaseReturnController, emptyTitle:'No purchase returns',
  statusOptions:['Pending','Approved','Completed','Cancelled'],
  defaultForm:{ supplierId:'',supplierName:'',returnDate:new Date().toISOString().split('T')[0],reason:'',items:[],totalAmount:0,status:'Pending',notes:'' },
  columns:(crud,openEdit)=>[
    { label:'Return No.', key:'returnNumber', render:v=><span style={{ fontFamily:'monospace', fontSize:12, color:C.danger }}>{v||'—'}</span> },
    { label:'Supplier', key:'supplierName', render:v=><div style={{ fontWeight:700 }}>{v}</div> },
    { label:'Return Date', key:'returnDate', render:v=>fmt(v) },
    { label:'Total', key:'totalAmount', render:v=><span style={{ fontWeight:700 }}>{money(v)}</span> },
    { label:'Reason', key:'reason', render:v=><div style={{ maxWidth:180, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', fontSize:12 }}>{v||'—'}</div> },
    { label:'Status', key:'status', render:v=><StatusBadge status={v}/> },
    { label:'', key:'actions', render:(_, r)=><ActionBtns onEdit={()=>openEdit(r)} onDelete={()=>crud.handleDelete(r.id,'this return')} /> },
  ],
  formFields:(f,set)=>[
    <FormField key="sup" label="Supplier Name *"><input style={S.input} value={f.supplierName} onChange={e=>set('supplierName',e.target.value)} /></FormField>,
    <FormField key="rd" label="Return Date *"><input type="date" style={S.input} value={f.returnDate} onChange={e=>set('returnDate',e.target.value)} /></FormField>,
    <FormField key="ta" label="Total Amount (₹)"><input type="number" style={S.input} value={f.totalAmount} onChange={e=>set('totalAmount',e.target.value)} /></FormField>,
    <FormField key="st" label="Status"><select style={S.select} value={f.status} onChange={e=>set('status',e.target.value)}>{['Pending','Approved','Completed','Cancelled'].map(s=><option key={s}>{s}</option>)}</select></FormField>,
    <FormField key="re" label="Reason" col={2}><textarea style={S.textarea} value={f.reason} onChange={e=>set('reason',e.target.value)} /></FormField>,
    <FormField key="no" label="Notes" col={2}><textarea style={{ ...S.textarea, minHeight:60 }} value={f.notes} onChange={e=>set('notes',e.target.value)} /></FormField>,
  ],
});
export default PurchaseReturnsPage;